import validateConfig from "../validateConfig";
const getCustomerTierId = async (params) => {
    const { config, authClient } = params;
    validateConfig(config);
    const loyaltyTier = await authClient.getClaim("loyaltyTier");
    if (loyaltyTier) {
        const tierConfig = config.tiers.find(({ id }) => id === loyaltyTier);
        if (tierConfig) {
            return loyaltyTier;
        }
    }
    return null;
};
export default getCustomerTierId;
